import React, { useEffect } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import PropTypes from 'prop-types';
import { getMsalConfig } from '../config/msal-config';
import { setMicroSoftToken } from '../services/business-details-service';
import logger from '../services/logger';

const DynamicMsalProvider = ({ children, clientId, tenantId }) => {

  const msalInstance = new PublicClientApplication(getMsalConfig(clientId, tenantId));

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        // Ensure MSAL instance is initialized
        await msalInstance.initialize();
        logger.info('MSAL initialized');
        // Handle redirect promise
        // const response = await msalInstance.handleRedirectPromise();
        // if (response) {
        //   logger.info('Response received: DynamicMsalProvider', response);
        //   setMicroSoftToken(response?.idToken);
        // }

        // Set up event callback
        const callbackId = msalInstance.addEventCallback((event) => {
          logger.info('Event Triggered:', event?.eventType, event);
          if (
            (event?.eventType === EventType.LOGIN_SUCCESS || event?.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
            event?.payload?.account
          ) {
            msalInstance.setActiveAccount(event.payload.account);
            logger.info('MSAL payload:', event?.payload);
            setMicroSoftToken(event?.payload?.idToken);
          }
        });

        // Cleanup callback on component unmount
        return () => {
          msalInstance.removeEventCallback(callbackId);
        };

      } catch (error) {
        console.error('Error initializing MSAL:', error);
      }
    };
    initializeMsal();
  }, [clientId, tenantId]);
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

DynamicMsalProvider.propTypes = {
  children: PropTypes.any,
  clientId: PropTypes.string,
  tenantId: PropTypes.string,
};

export default DynamicMsalProvider;
